// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex[data-v-1f6f6630] {\n  display: flex;\n  align-items: center;\n}\n.el-icon-circle-plus-outline[data-v-1f6f6630],\n.el-icon-remove-outline[data-v-1f6f6630] {\n  font-size: 26px;\n  color: #53a8ff;\n  margin-left: 10px;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
